import React from 'react';
import { sendChatComposerPatientNowLead } from '../../../../redux/leadModalActions.js';
import GenericLeadSyncComposer from '../GenericLeadSyncComposer.js';

const FourthDimensionAddPatientComposer = () => {
  return <GenericLeadSyncComposer id={'patient-now'} title={'Patient Now'} syncMethod={sendChatComposerPatientNowLead} />;
};

export default FourthDimensionAddPatientComposer;
